import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Env } from '../env';
import { Observable } from 'rxjs/Observable';
import { Permission } from '../models/permission';
import { PermissionDto } from '../dto/permission.dto';

@Injectable()
export class PermissionService {

  constructor(private http: HttpClient, private global: Env) {}

  getAll(id): Observable<Permission[]> {
    const url = this.global.access + '/all/' + id;
    return this.http.get(url).map((res: Permission[]) => {
      return res;
    });
  }

  update(dto: PermissionDto) {
    const url = this.global.access;
    return this.http.post(url, JSON.stringify(dto));
  }
}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/services/permission.service.ts